'use client';

import type { FC } from 'react';
import { StaticPage } from '@/components/StaticPage';
import type { StaticPageProps } from '@/components/StaticPage/types';
import type { IWithContentByLicense } from '../helpers';
import { useContentByLicense } from '../hooks/useContentByLicense';

interface LicensedStaticPageProps
  extends Omit<StaticPageProps, 'mainText'>,
    IWithContentByLicense {}

export const LicensedStaticPage: FC<LicensedStaticPageProps> = ({
  contentByLicense,
  ...props
}) => {
  const mainText = useContentByLicense(contentByLicense);

  return <StaticPage {...props} mainText={mainText} />;
};
